/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountKeyValues {
    getFixupPrototypeFunction() { return ServiceAccountKeyValues.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountKeyValues>): ServiceAccountKeyValues {
        let obj = Object.assign(new ServiceAccountKeyValues(), model);
        ServiceAccountKeyValues.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountKeyValues>): ServiceAccountKeyValues {
        if (!model) return null;
        return ServiceAccountKeyValues.newInstance(<ServiceAccountKeyValues> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountKeyValues) {
        if (!obj) return;

        models.ServiceAccountKeyValues.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountKeyValues): boolean {
        Object.setPrototypeOf(obj, ServiceAccountKeyValues.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.values_by_key) {
            for (let val of this.values_by_key) {
                models.KeyValues.fixupPrototype(val);
            }
        }
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

    /**
     * List of tag key/value pairs for an account
     */
    values_by_key: Array<models.KeyValues>;

}
